import { render, staticRenderFns } from "./DamageShortMetricWidget.vue?vue&type=template&id=225bd3ce&scoped=true"
import script from "./DamageShortMetricWidget.vue?vue&type=script&lang=ts"
export * from "./DamageShortMetricWidget.vue?vue&type=script&lang=ts"
import style0 from "./DamageShortMetricWidget.vue?vue&type=style&index=0&id=225bd3ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225bd3ce",
  null
  
)

export default component.exports